// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vMwEkiww3ctt8pBoKDvr {
  position: relative;
  border: 1px solid #DCDCDC;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
}
.qU2lJ3HWIt7_7Iw0Ui2O {
  background-color: #e9e9e9;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 0px 5px inset;
}
.y9NONUc3S7ZHcEyfl6zA {
  border: 1px solid #B6B6B6;
  width: 14px;
  height: 14px;
}
.zNWuVlWq1XAgTRRY8W_i {
  padding: 11px 0px 9px 10px;
}
._UGBMJhGEcAj9YoIHwYQ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #B8B8B8;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
}
.m8BMHb1tDT63ZGc9fiHB {
  color: #808080;
  position: absolute;
  top: 5px;
  left: 3px;
  right: 0;
  padding: 8px 9px;
  font-size: 11px;
  cursor: pointer;
}
.ftPNsoUT289E1HjC7ZwF {
  position: absolute;
  z-index: 1000;
  top: 33px;
  left: 0;
  font-size: 13px;
  background-color: white;
  width: 180px;
  box-shadow:
    0 3px 20px rgba(89, 105, 129, .6), 0 1px 2px rgba(0, 0, 0, .05), 0 0 0 1px rgba(89, 105, 129, .1);
  border-radius: 4px;
  cursor: pointer;
}

.KKnoTMKmJRZIFtCs0XtI {
  padding: 8px 0 7px 10px;
  color: #444;
  border-bottom: 1px solid #e2e2e2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-toolbar/button-select-interests.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,OAAO;EACP,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ;qGACmG;EACnG,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gCAAgC;AAClC","sourcesContent":[".container {\n  position: relative;\n  border: 1px solid #DCDCDC;\n  border-radius: 4px;\n  width: 120px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n.containerPressed {\n  background-color: #e9e9e9;\n  box-shadow: rgba(0, 0, 0, 0.06) 0px 0px 5px inset;\n}\n.innerBox {\n  border: 1px solid #B6B6B6;\n  width: 14px;\n  height: 14px;\n}\n.innerBoxContainer {\n  padding: 11px 0px 9px 10px;\n}\n.icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: #B8B8B8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n.check {\n  color: #808080;\n  position: absolute;\n  top: 5px;\n  left: 3px;\n  right: 0;\n  padding: 8px 9px;\n  font-size: 11px;\n  cursor: pointer;\n}\n.dropdownContainer {\n  position: absolute;\n  z-index: 1000;\n  top: 33px;\n  left: 0;\n  font-size: 13px;\n  background-color: white;\n  width: 180px;\n  box-shadow:\n    0 3px 20px rgba(89, 105, 129, .6), 0 1px 2px rgba(0, 0, 0, .05), 0 0 0 1px rgba(89, 105, 129, .1);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.dropdownItem {\n  padding: 8px 0 7px 10px;\n  color: #444;\n  border-bottom: 1px solid #e2e2e2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `vMwEkiww3ctt8pBoKDvr`,
	"containerPressed": `qU2lJ3HWIt7_7Iw0Ui2O`,
	"innerBox": `y9NONUc3S7ZHcEyfl6zA`,
	"innerBoxContainer": `zNWuVlWq1XAgTRRY8W_i`,
	"icon": `_UGBMJhGEcAj9YoIHwYQ`,
	"check": `m8BMHb1tDT63ZGc9fiHB`,
	"dropdownContainer": `ftPNsoUT289E1HjC7ZwF`,
	"dropdownItem": `KKnoTMKmJRZIFtCs0XtI`
};
export default ___CSS_LOADER_EXPORT___;
